import React from 'react';
import { styled } from '@mui/material/styles';
import MuiSwitch from '@mui/material/Switch';
import { COLORS } from '../../utils/Application_Constants';

const StyledSwitch = styled(MuiSwitch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
            '& + .MuiSwitch-track': {
                opacity: 1,
                borderColor: theme.palette.primary.main,
            },
            '& .MuiSwitch-thumb': {
                color: COLORS.WHITE,
            },
        },
    },
    '& .MuiSwitch-track': {
        borderRadius: 12,
        boxSizing: 'border-box',
        height: 22,
        backgroundColor: COLORS.WHITE,
        border: '2px solid #AAA',
        opacity: 1,
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main)
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        color: '#AAA',
        width: 14,
        height: 14,
        margin: 3,
    },
}));

const Switch = React.forwardRef((props, ref) => <StyledSwitch {...props} ref={ref} />);

export default Switch;
